import { combineReducers } from 'redux';

import router from './router';
import invitation from './invitation';

export default combineReducers({
  router,
  invitation,
});
